import PropTypes from 'prop-types';
import React, { Component } from 'react';

import FormattedTime from '../../../components/FormattedTime';

export default class BaselineItem extends Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    createdAt: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.func,
    ]),
    onDelete: PropTypes.func,
  };

  _onClick = () => {
    this.props.onDelete(this.props.id, this.props.name);
  }

  render = () => {
    const { name, createdAt } = this.props;

    return (
      <div className="list-group-item list-group-item-action flex-column align-items-start">
        <div className="d-flex w-100 justify-content-between">
          <h6 className="mb-1">{name}</h6>
          <small>
            <FormattedTime
              value={createdAt}
              format={'MMMM DD, YYYY, h:mm:ss A'}
            />
          <i
            className="fa fa-trash fa-lg text-danger ml-3"
            aria-hidden="true"
            onClick={this._onClick}
          />
          </small>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/Baselines/BaselineItem.js